import styled from "@emotion/styled";
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import theme from "../../theme";
import { shouldForwardProp } from "../../common/Common.style";

export const TemplateAccessWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
  gap: 12px;
`;

export const RolesContainer = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

type RoleLabelProp = {
  statusColor?: string;
};

export const RoleLabel = styled(FormControlLabel, {
  shouldForwardProp: prop =>
    shouldForwardProp<RoleLabelProp>(["statusColor"], prop),
})<RoleLabelProp>(({ statusColor }) => ({
  color: statusColor || theme.palette.primary.main,
}));

export const StyledRadio = styled(Radio, {
  shouldForwardProp: prop =>
    shouldForwardProp<RoleLabelProp>(["statusColor"], prop),
})<RoleLabelProp>(({ statusColor }) => ({
  color: statusColor || theme.palette.primary.main,
}));

export const CancelButton = styled(Button)`
  text-transform: none;
`;
